var render = function render(){var _vm=this,_c=_vm._self._c;return _c('df-button',{staticClass:"df-button--text-primary d-flex justify-space-around align-center",attrs:{"show":!_vm.isMobile,"flank":'fa-pull-right fa-1x',"icon":"share-square","width-slot":"120px"},on:{"click":_vm.redirectUSAFeedback}},[_vm._v(" Submit feedback ")])
}
var staticRenderFns = []

export { render, staticRenderFns }